import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import StepsIcon from "../../../assets/Fibo/icons/StepsIcon";
import BriaSlider, { IBriaSliderProps } from "../../../components/common/BriaSlider/BriaSlider";
import { FIBO_EDIT_STEPS_DEFAULT_PROPS } from "../../../constants/FiboEditConstants";
import { useAppStore } from "../../../hooks/useStores";
import FiboPopoverButton from "../../Fibo/Config/Popover/FiboPopoverButton";
import styles from "./FiboEditSteps.module.scss";

export interface IGenerationStepsSliderProps extends IBriaSliderProps {
	steps: number;
	min: number;
	max: number;
}

const GenerationStepsSlider = ({ steps, onChange, min, max, ...props }: IGenerationStepsSliderProps) => {
	return (
		<BriaSlider
			value={steps}
			onChange={onChange}
			step={1}
			min={min}
			max={max}
			valueLabelDisplay="auto"
			marks={[0, 0.25, 0.5, 0.75, 1].map((f) => {
				const value = min + Math.round((max - min) * f);
				return { value, label: String(value) };
			})}
			{...props}
		/>
	);
};

const FiboStepsButton = () => {
	const { t } = useTranslation("fibo_edit", { keyPrefix: "lab.config.steps" });
	const { fiboStore } = useAppStore();
	const { fiboEditStore } = fiboStore;

	const DEFAULTS_PROPS = FIBO_EDIT_STEPS_DEFAULT_PROPS;

	return (
		<FiboPopoverButton
			icon={<StepsIcon />}
			buttonText={String(fiboEditStore.config?.steps_num ?? t("placeholder"))}
			tooltip={t("tooltip")}
		>
			<GenerationStepsSlider
				className={styles.slider}
				valueLabelDisplay="off"
				steps={fiboEditStore.config.steps_num ?? DEFAULTS_PROPS.steps}
				min={DEFAULTS_PROPS.min}
				max={DEFAULTS_PROPS.max}
				onChange={(_, value) => (fiboEditStore.config.steps_num = value as number)}
			/>
		</FiboPopoverButton>
	);
};

export default observer(FiboStepsButton);
